// GENERATED by scripts\gen-rule-presence.js from data\YCP_RULE_SELECTION_LEDGER.tsv - DO NOT EDIT BY HAND.
// Track 6 item 6a-12 (task list section 243). Presence of each violation id across every CRED-1 run of the
// CONTROL description recorded in the ledger. This characterises the analysis on ONE input - the control -
// and says nothing about any member's claim (task list section 20's limit, still binding). A rule seen in
// some runs and not others is INTERMITTENT: the officer is told the rate; the claimant is never shown it.
export const RULE_PRESENCE = {
 "runs": 173,
 "firstRun": "2026-08-26T22:26:12.927Z",
 "lastRun": "2026-09-14T23:09:59.536Z",
 "generatedAt": "2026-09-14T23:13:00.279Z",
 "rates": {
  "CLAIM-presentment": {
   "n": 3,
   "rate": 0.017,
   "positions": {
    "3": 3
   }
  },
  "CLAIM-remedy-computation": {
   "n": 54,
   "rate": 0.312,
   "positions": {
    "3": 54
   }
  },
  "PAY-basis-of-pay-rate-applied": {
   "n": 67,
   "rate": 0.387,
   "positions": {
    "3": 67
   }
  },
  "PAY-minimum-guarantee-called-not-used": {
   "n": 6,
   "rate": 0.035,
   "positions": {
    "3": 6
   }
  },
  "PAY-overtime-rate": {
   "n": 8,
   "rate": 0.046,
   "positions": {
    "3": 6,
    "4": 2
   }
  },
  "QUAL-qualifying": {
   "n": 1,
   "rate": 0.006,
   "positions": {
    "3": 1
   }
  },
  "SEN-exercise-of-seniority-displacement": {
   "n": 22,
   "rate": 0.127,
   "positions": {
    "2": 8,
    "3": 14
   }
  },
  "WORK-calls-call-order": {
   "n": 17,
   "rate": 0.098,
   "positions": {
    "3": 17
   }
  },
  "WORK-extra-list-operation-rotation": {
   "n": 168,
   "rate": 0.971,
   "positions": {
    "2": 164,
    "3": 4
   }
  },
  "WORK-overtime-distribution": {
   "n": 173,
   "rate": 1,
   "positions": {
    "1": 173
   }
  }
 }
};
